import { render, staticRenderFns } from "./reDetail.vue?vue&type=template&id=11aa7859&"
import script from "./reDetail.vue?vue&type=script&lang=js&"
export * from "./reDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11aa7859')) {
      api.createRecord('11aa7859', component.options)
    } else {
      api.reload('11aa7859', component.options)
    }
    module.hot.accept("./reDetail.vue?vue&type=template&id=11aa7859&", function () {
      api.rerender('11aa7859', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/DestinationBusiness/detail/reDetail.vue"
export default component.exports